import {projectCommand} from '../projects';
import type {PhotoUploadQueue} from './uploadQueue';
import type {RetainedUpload} from './uploadTypes';

/** Explicit, connected planning action; the common queue retains photo bytes. */
export async function createCapturedProject(queue:PhotoUploadQueue,row:RetainedUpload,stillAllowed:()=>boolean):Promise<RetainedUpload>{
 const draft=row.projectDraft;if(!draft)return row;
 if(!stillAllowed())throw new Error('Administrator access is required to create a project.');
 if(!navigator.onLine)throw new Error('Connect to create this project. Your photo and title stay saved on this device.');
 const title=draft.title.trim();if(!title||title.length>160)throw new Error('Give the project a title of up to 160 characters.');
 const submitted={...draft,title,submitted:true};
 await queue.revise(row.id,row.manifest,row.reviewTags,row.destinationLabel,{destinationConfirmed:false,projectDraft:submitted});
 if(!stillAllowed())throw new Error('Account or project access changed. Reopen this saved photo.');
 // Persist before dispatch; a lost response/reload replays the same request.
 const result=await projectCommand(row.farmId,undefined,{action:'create',name:title,operation_id:draft.operationId});
 if(!stillAllowed())throw new Error('Account or project access changed. Reopen this saved photo.');
 return queue.resolveProject(row.id,draft.operationId,result.id,title);
}
